import React, { useEffect } from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";

export default function CustomerFaqs() {


      useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top when component is mounted
      }, []);
  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3 className="text-center">Customer FAQs</h3>
            <Row>
              <Col lg={8} className="mx-auto">
                <div className="my-profile-title">
                  <h4>FAQs</h4>
                </div>
                <div className="faq-list-accro">
                  <Accordion flush>
                    {/* FAQ 1 */}
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>What is SparkPro?</Accordion.Header>
                      <Accordion.Body>
                        SparkPro is the UK’s dedicated platform for finding
                        certified electricians. We connect customers with
                        trusted professionals for all types of electrical work,
                        making it easy to hire the right electrician for your
                        needs.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 2 */}
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        How does SparkPro work?
                      </Accordion.Header>
                      <Accordion.Body>
                        Posting a job on SparkPro is simple. Just enter the
                        details of your electrical job, and local certified
                        electricians will be notified and can respond with
                        quotes. You can then compare electricians, read reviews,
                        and choose the best professional for the job.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 3 */}
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>How do I post a job?</Accordion.Header>
                      <Accordion.Body>
                        To post a job, simply search for the service you require
                        or log in to your SparkPro account and click “Request
                        Another Service.” Fill out the required details, and
                        once submitted, electricians in your area will be
                        notified and can send quotes.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 4 */}
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                        Is SparkPro free to use?
                      </Accordion.Header>
                      <Accordion.Body>
                        Yes! SparkPro is completely free for customers. There
                        are no hidden charges for posting a job or receiving
                        quotes from electricians.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 5 */}
                    <Accordion.Item eventKey="4">
                      <Accordion.Header>
                        How do I choose the right electrician?
                      </Accordion.Header>
                      <Accordion.Body>
                        You can compare electricians based on their profile,
                        reviews, qualifications, and pricing. Look for verified
                        professionals and read customer feedback to ensure you
                        hire someone reliable.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 6 */}
                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                        Are the electricians on SparkPro qualified?
                      </Accordion.Header>
                      <Accordion.Body>
                        {/* Yes, you can upgrade or downgrade your subscription at
                                                any time to match your needs. */}
                        Yes. You can view each electrician’s profile to check
                        their accreditations and qualifications. If they’re
                        marked as verified by SparkPro, it means we’ve reviewed
                        their details and confirmed their credentials.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 7 */}
                    <Accordion.Item eventKey="6">
                      <Accordion.Header>
                        How do I communicate with an electrician?
                      </Accordion.Header>
                      <Accordion.Body>
                        {/* Once an electrician responds to your job post, you can chat with them directly through the SparkPro platform to discuss the job details, ask questions, and confirm pricing. */}
                        {/* Once an electrician responds to your job, they’ll
                        usually contact you by phone or email. If they’re a
                        Premium member, you can view their contact details
                        directly through their profile. */}

                        After an electrician responds to your job, both you and the electrician will have access to each other’s contact information, allowing you to communicate directly.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 8 */}
                    <Accordion.Item eventKey="7">
                      <Accordion.Header>
                        How do I accept a quote and hire an electrician?
                      </Accordion.Header>
                      <Accordion.Body>
                        After reviewing the quotes, confirm your choice of
                        electrician, and arrange a date and time for the work to
                        be completed.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 9 */}
                    <Accordion.Item eventKey="8">
                      <Accordion.Header>
                        How do I pay for the job?
                      </Accordion.Header>
                      <Accordion.Body>
                        Payment is arranged directly between you and the
                        electrician. SparkPro does not process payments. Be sure
                        to discuss payment terms before the work begins.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 10 */}
                    <Accordion.Item eventKey="9">
                      <Accordion.Header>
                        What if I have an issue with an electrician?
                      </Accordion.Header>
                      <Accordion.Body>
                        If you experience any issues, we recommend discussing
                        the matter directly with the electrician first. If
                        further assistance is needed, you can contact SparkPro
                        support for help.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 11 */}
                    <Accordion.Item eventKey="10">
                      <Accordion.Header>
                        Can I edit or cancel my listing?
                      </Accordion.Header>
                      <Accordion.Body>
                        {/* Yes, you can edit your job details or cancel a posting at any time through your dashboard. If you’ve already accepted a quote, be sure to notify the electrician before cancelling. */}
                        Editing listings is not permitted, but you can cancel
                        your listing at any time through your dashboard. If
                        you’ve already accepted a quote, be sure to notify the
                        electrician before cancelling.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 12 */}
                    <Accordion.Item eventKey="11">
                      <Accordion.Header>
                        How can I contact SparkPro for support?
                      </Accordion.Header>
                      <Accordion.Body>
                        Need help? You can contact us at
                        <b>
                          {" "}
                          <a
                            style={{ textDecoration: "none" }}
                            href="mailto: contact@sparkpro.app"
                          >
                            {" "}
                            contact@sparkpro.app
                          </a>{" "}
                        </b>
                        and we'll get back to you as soon as possible.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </Layout>
    </>
  );
}
